import { createAtom, type IAtom } from 'mobx';
import { Services } from '../index';

/**
 * Mobx Trigger
 *
 * This can be used to force a mobx autorun to cause the autorun to re-run
 *
 */
export class IkeTrigger {
	atom: IAtom;
	timeout: number = null;

	constructor(name: string) {
		this.atom = createAtom(`trigger: ${name} `);
	}

	/** Wether the trigger is scheduled to run */
	get isTriggering() {
		return this.timeout != null;
	}

	/** Report that the trigger has changed causing the autorun to fire */
	private run = () => {
		if (this.isTriggering) {
			this.timeout = null;
		}
		this.atom.reportChanged();
	};

	/** Observe the trigger, generally used inside of a autorun */
	observe() {
		this.atom.reportObserved();
	}

	/** Schedule the trigger to run on the next animation frame*/
	trigger() {
		if (this.isTriggering) {
			return;
		}
		this.timeout = Services.Window.window.requestAnimationFrame(this.run);
	}
}
